export type AppEnvironment = 'dev' | 'test' | 'prod';
export type EnvBadgeKind = 'local' | 'dev' | 'test';

// Środowisko bierzemy z projektu Firebase, z którym aplikacja faktycznie się łączy (także na localhost),
// a dopiero gdy go brak, z trybu Vite (build:dev/test/prod).
export const resolveAppEnvironment = (projectId?: string, mode?: string): AppEnvironment | null => {
  const id = (projectId || '').toLowerCase();
  if (id.endsWith('-prod')) return 'prod';
  if (id.endsWith('-test')) return 'test';
  if (id.endsWith('-dev')) return 'dev';

  const m = (mode || '').toLowerCase();
  if (m === 'prod' || m === 'production') return 'prod';
  if (m === 'test') return 'test';
  if (m === 'dev' || m === 'development') return 'dev';
  return null;
};

export const isLocalHost = (hostname?: string): boolean => {
  const h = (hostname || '').toLowerCase();
  return h === 'localhost' || h === '127.0.0.1' || h === '[::1]' || h === '::1';
};

// Lokalnie zawsze „LOCALHOST” (projekt w tooltipie), na hostingu DEV/TEST, na produkcji nic.
export const resolveEnvBadgeKind = (
  env: AppEnvironment | null,
  hostname?: string,
): EnvBadgeKind | null => {
  if (isLocalHost(hostname)) return 'local';
  if (env === 'dev' || env === 'test') return env;
  return null;
};

export const FIREBASE_PROJECT_ID: string = import.meta.env.VITE_FIREBASE_PROJECT_ID || '';

export const APP_ENVIRONMENT = resolveAppEnvironment(FIREBASE_PROJECT_ID, import.meta.env.MODE);

export const ENV_BADGE_KIND = resolveEnvBadgeKind(
  APP_ENVIRONMENT,
  typeof window !== 'undefined' ? window.location.hostname : undefined,
);
